import { useNavigate, useParams } from "react-router";
import Button from "../../components/common/button";
import { SidebarToggleSvg } from "../../icons";
import { removeAuthToken } from "../../utils/helpers";
import { queryClient } from "../../App";

type IHeaderTypes = {
  onToggleSidebar: () => void;
};

const Header = ({ onToggleSidebar }: IHeaderTypes) => {
  const navigate = useNavigate();
  const params = useParams();

  const handleLogout = () => {
    localStorage.removeItem("token");
    removeAuthToken();
    queryClient.setQueriesData({ queryKey: ["auth-user"] }, null);
    navigate(`/${params.hotelcode}`);
  };
  return (
    <div className="flex items-center justify-between px-6 py-[30px] h-[72px] bg-white">
      <div className="cursor-pointer" onClick={onToggleSidebar}>
        <SidebarToggleSvg />
      </div>
      <Button
        className="ml-2 rounded bg-secondary text-white"
        onClick={handleLogout}
      >
        Logout
      </Button>
    </div>
  );
};

export default Header;
